exports.VERSION = "v1";
exports.BASE_URL = `https://swatch-v1.herokuapp.com/api/${this.VERSION}/`;
